import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { expenseService } from '@kss/api';
import type { ExpenseCreate } from '@kss/api';
import { loadStoreOptions, loadAccountOptions } from '../shared/formLoaders';

const columns: BulkColumn<ExpenseCreate>[] = [
  { key: 'expenseDate', header: 'Date', required: true, dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'amount', header: 'Amount', dataType: 'number', parse: parseNum as never, required: true, sample: '2500' },
  { key: 'category', header: 'Category', sample: 'Utilities' },
  { key: 'vendor', header: 'Vendor' },
  { key: 'paymentMethod', header: 'Method', sample: 'Bank' },
  { key: 'reference', header: 'Reference' },
  { key: 'accountId', header: 'Account', dataType: 'lookup', loadOptions: loadAccountOptions },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'description', header: 'Description' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkExpense() {
  return (
    <BulkSpreadsheet<ExpenseCreate> title="Bulk import expenses" entityLabel="expense" backPath="/panel/expenses" columns={columns} module="Expense"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, amount: Number(r.amount ?? 0), isActive: r.isActive ?? true }));
        const created = await expenseService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
